// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._1e0c1o8l{display:inline-block}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
